(function() {
    angular
        .module("app")
        .factory("messagePreviewService", messagePreviewService)

    messagePreviewService.$inject = [
        "$timeout"
    ]

    function messagePreviewService(
        $timeout
    ) {

        const service = {}

        service.getController = async (messageBoard, displayWidth) => {

            return await FMMessage.GetPreviewController(messageBoard, displayWidth)

        }

        const generatePreview = (controller, preview, containerElementID) => {

            if (controller !== undefined && preview !== undefined) {

                // Combining Timeouts and Angular Element because we need the DOM to be finished loading to get the Container Element

                $timeout(() => {

                    angular.element(() => {

                        $timeout(() => {

                            const container = document.getElementById(containerElementID)

                            if (container) {

                                for (const child of container.children) {
                                    container.removeChild(child)
                                }

                                container.appendChild(preview.canvasElement)

                            }
                        }, 1)
                    })
                }, 1)
            }
        }

        service.generatePreviewFromMulti = (controller, multi, containerElementID) => {

            if (controller !== undefined) {

                const preview = controller.fromMulti(multi)

                generatePreview(controller, preview, containerElementID)

            }
        }

        return service

    }
})()
